__webpack_require__.p = "/dst-uat-egypt/";